<script>
import List from '../../baseComponents/list'
import { isDateKey, themeDates } from '../../variables'

export default {
	extends: List,
	props: ['global'],
	data() {
		return {
			defaultSort: "-Date d'inscription",
			rowClick: (item) => {
				if (!this.global) {
					this.$router.push({ name: 'UserDetail', params: { botId: this.$route.params.botId, userId: item._id } })
				}
			},
			items: [],
		}
	},

	computed: {
		bots() {
			return this.$store.getters.bots
		},
		botUserVariables() {
			return this.$store.getters.botUserVariables
		},
		userGroups() {
			return this.$store.getters.userGroups
		},
	},
	methods: {
		initVariables() {
			const userVariables = []
			if (this.global) {
				userVariables.push({
					header: 'Bots',
					sort: false,
					filter: {
						type: 'multi-select',
						values: this.bots,
						itemText: 'name',
						itemValue: '_id',
						name: 'bots.bot',
					},
					value: (item) => {
						return this.bots
							.filter((bot) => item.bots.find((userBo) => userBo.bot === bot._id))
							.map((bot) => bot.name)
							.join(', ')
					},
				})

				// TODO add bo where he is
				;['prenom', 'nom', 'sms', 'genre', 'nomAnimal'].forEach((variableKey) => {
					userVariables.push({
						header: variableKey,
						sort: false,
						filter: {
							type: 'custom',
							inputType: 'text',
							customFilter: (cellValue) => {
								return 'userVariables:$elemMatch:$and:[name:$eq:' + variableKey + ';value:$regex:' + cellValue + ']'
							},
						},
						value: (item) => {
							let variable = item.userVariables.find((el) => el.name === variableKey)
							if (variable) {
								return variable.value
							}
							return ''
						},
					})
				})
			} else if (this.botUserVariables && this.botUserVariables.length > 0) {
				for (let i = 0; i < this.botUserVariables.length; i++) {
					if (!this.botUserVariables[i].bot || this.botUserVariables[i].bot === this.$route.params.botId) {
						const isDate = isDateKey(this.botUserVariables[i].name)

						userVariables.push({
							header: (this.botUserVariables[i].bot ? 'specific:' : '') + this.botUserVariables[i].name,
							sort: false,
							filter: isDate
								? false
								: {
										type: 'custom',
										inputType: 'text',
										customFilter: (cellValue) => {
											return (
												'userVariables:$elemMatch:$and:[_id:$eq:' +
												this.botUserVariables[i]._id +
												';value:$regex:' +
												cellValue +
												']'
											)
										},
								  },
							value: (item) => {
								let variable = item.userVariables.find((el) => el._id === this.botUserVariables[i]._id)
								if (variable) {
									return isDate && variable.value ? this.$options.filters.formatDate(variable.value) : variable.value
								}
								return ''
							},
						})
					}
				}
			}
			this.items = [
				{
					header: 'Id botnation',
					value: (item) => item.botNationId,
					sort: 'botNationId',
					filter: { name: 'botNationId' },
				},
				{
					header: "Date d'inscription",
					value: (item) => this.$options.filters.formatDate(item.createdAt),
					sort: 'createdAt',
					filter: false,
				},
				{
					header: 'Date parcours',
					value: (item) => {
						let variable = item.userVariables.find(
							(el) => themeDates.find((dateKey) => dateKey === el.name) && el.value,
						)
						if (variable) {
							return this.$options.filters.formatDate(variable.value)
						}
						return ''
					},
					filter: false,
				},
				...userVariables,
				{
					header: 'Cliniques',
					sort: false,
					filter: false,
					value: (item) =>
						item.userGroups.reduce((acc, el) => {
							let group = this.userGroups.find((group) => group._id === el)
							return acc + (acc.length === 0 ? '' : ', ') + (group ? group.name : '')
						}, ''),
				},
			]

			if (this.addedItems) {
				this.items = this.items.concat(this.addedItems)
			}
		},
	},
	mounted() {
		this.initVariables()
	},
	watch: {
		botUserVariables() {
			this.initVariables()
		},
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/users/user.list.vue